(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4756);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./head/index.tsx
// components/head.js



const Head = (param)=>/*#__PURE__*/ {
    let { children , title  } = param;
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    charSet: "UTF-8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1.0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    httpEquiv: "x-ua-compatible",
                    content: "ie=edge"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "theme-color",
                    content: "#ff827b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "Nadine Pesso | Frontend Developer",
                    content: "Portfolio"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Nadine Pesso | Frontend Developer Portfolio"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "https://nadinepesso.com"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "apple-touch-icon",
                    href: "/assets/logo/logo_black.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "shortcut icon",
                    type: "image/png",
                    href: "assets/logo/favicon.ico"
                }),
                children
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/CookieConsent/styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--primary);\n  border-color: var(--primary);\n  color: var(--neutral_01);\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 2rem;\n  left: 2rem;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2.4rem;\n\n  background-color: var(--neutral_02);\n  border-radius: 0.8rem;\n  box-shadow: 0 4px 8px #1f292e40;\n  color: var(--dark_01);\n  font-size: 1.6rem;\n  line-height: 1.25;\n  padding: 2.4rem 3.2rem;\n  text-align: center;\n\n  width: calc(100% - 4rem);\n\n  @media (min-width: 700px) {\n    left: unset;\n    right: 2rem;\n\n    flex-direction: row;\n    gap: 6.4rem;\n\n    text-align: left;\n\n    width: auto;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1.6rem;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--neutral_01);\n  border: 1px solid var(--neutral_03);\n  border-radius: 0.8rem;\n  color: var(--dark_01);\n  cursor: pointer;\n  box-shadow: 0 2px 4px #1f292e10;\n  font-size: 1.6rem;\n  padding: 0.8rem 1.6rem;\n\n  &:hover {\n    box-shadow: 0 2px 4px #1f292e40;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const primaryBtnStyles = (0,styled_components_browser_esm/* css */.iv)(_templateObject());
const styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b2077a-0"
})(_templateObject1());
const Actions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b2077a-1"
})(_templateObject2());
const Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f3b2077a-2"
})(_templateObject3(), (param)=>{
    let { primary  } = param;
    return primary && primaryBtnStyles;
});

// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(7041);
;// CONCATENATED MODULE: ./components/CookieConsent/index.tsx




const CookieConsent = ()=>{
    const [consent, setConsent] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        setConsent((0,lib.hasCookie)("localConsent"));
    }, []);
    const acceptCookie = ()=>{
        setConsent(true);
        (0,lib.setCookie)("localConsent", "true", {
            maxAge: 60 * 60 * 24 * 365
        });
        // eslint-disable-next-line no-undef
        gtag("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted"
        });
    };
    const denyCookie = ()=>{
        setConsent(true);
        (0,lib.setCookie)("localConsent", "false", {
            maxAge: 60 * 60 * 24 * 365
        });
    };
    if (consent === true) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
        children: [
            "This website uses cookies to track page views.",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: ()=>denyCookie(),
                        children: "Reject"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: ()=>{
                            acceptCookie();
                        },
                        primary: true,
                        children: "Accept"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Social/styles.tsx

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    height: 3rem;\n    width: 3rem;\n\n    path {\n      fill: ",
        ";\n      transition: fill 0.6s ease 0s;\n    }\n  }\n\n  &:hover {\n    transform: ",
        ";\n    transition: transform 0.2s ease 0s;\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}

const IconLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b19b6908-0"
})(styles_templateObject(), (param)=>{
    let { color  } = param;
    return color && color;
}, (param)=>{
    let { animated  } = param;
    return animated ? "translateY(-2px)" : "none";
}, (param)=>{
    let { hoverColor  } = param;
    return hoverColor && hoverColor;
});

;// CONCATENATED MODULE: ./assets/icons/github.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
  })));
};
/* harmony default export */ var github = (SvgGithub);
;// CONCATENATED MODULE: ./assets/icons/linkedin.svg
var linkedin_path;
function linkedin_extends() { linkedin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_extends.apply(this, arguments); }

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), linkedin_path || (linkedin_path = /*#__PURE__*/react.createElement("path", {
    d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
  })));
};
/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./assets/icons/mail.svg
var mail_path;
function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", mail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), mail_path || (mail_path = /*#__PURE__*/react.createElement("path", {
    d: "M256 352c-16.53 0-33.06-5.422-47.16-16.41L0 173.2V400c0 26.5 21.49 48 48 48h416c26.51 0 48-21.49 48-48V173.2L303.2 335.7C289.1 346.6 272.5 352 256 352zM16.29 145.3l212.2 165.1c16.19 12.6 38.87 12.6 55.06 0l212.2-165.1C505.1 137.3 512 125 512 112c0-26.51-21.5-48-48-48H48C21.49 64 0 85.49 0 112c0 13 6.01 25.3 16.29 33.3z"
  })));
};
/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ./assets/icons/phone.svg
var phone_path;
function phone_extends() { phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), phone_path || (phone_path = /*#__PURE__*/react.createElement("path", {
    d: "m18.92 351.2 108.5-46.52c12.78-5.531 27.77-1.801 36.45 8.98l44.09 53.82c69.25-34 125.5-90.31 159.5-159.5l-53.81-44.04c-10.75-8.781-14.41-23.69-8.974-36.47l46.51-108.5c6.094-13.91 21.1-21.52 35.79-18.11l100.8 23.25c14.25 3.25 24.22 15.8 24.22 30.46 0 252.3-205.2 457.5-457.5 457.5-14.67 0-27.18-9.968-30.45-24.22L.796 387.05C-2.571 372.4 5.018 357.2 18.92 351.2z"
  })));
};
/* harmony default export */ var phone = (SvgPhone);
;// CONCATENATED MODULE: ./assets/icons/xing.svg
var xing_path;
function xing_extends() { xing_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return xing_extends.apply(this, arguments); }

var SvgXing = function SvgXing(props) {
  return /*#__PURE__*/react.createElement("svg", xing_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512"
  }, props), xing_path || (xing_path = /*#__PURE__*/react.createElement("path", {
    d: "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
  })));
};
/* harmony default export */ var xing = (SvgXing);
;// CONCATENATED MODULE: ./components/Social/index.tsx







const Social_Social = (param)=>{
    let { animated =false , className ="" , color ="var(--secondary)" , hoverColor ="var(--neutral_01)" , link , type ="github"  } = param;
    const renderIcon = ()=>{
        switch(type){
            case "calendly":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(phone, {});
            case "linkedin":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin, {});
            case "github":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(github, {});
            case "mail":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mail, {});
            case "xing":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(xing, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(github, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
        animated: animated,
        "aria-label": type,
        className: className,
        color: color,
        hoverColor: hoverColor,
        href: link,
        target: "_blank",
        children: renderIcon()
    });
};

;// CONCATENATED MODULE: ./components/Text/styles.tsx

function Text_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--dark_01);\n  font-size: 2rem;\n  font-weight: 200;\n  line-height: 1.5;\n  text-align: ",
        ";\n"
    ]);
    Text_styles_templateObject = function() {
        return data;
    };
    return data;
}

const StyledText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-40ea342b-0"
})(Text_styles_templateObject(), (param)=>{
    let { centered  } = param;
    return centered ? "center" : "left";
});

;// CONCATENATED MODULE: ./components/Text/index.tsx


const Text = (param)=>{
    let { className ="" , children , centered =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
        className: className,
        centered: centered,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/styles.tsx

function Title_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: var(--secondary);\n      font-size: 2.4rem;\n    "
    ]);
    Title_styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 1.8rem;\n    "
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 4rem;\n  margin: 2rem 0;\n  text-align: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  @media (min-width: 700px) {\n    ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const StyledTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd92b495-0"
})(_templateObject4(), (param)=>{
    let { centered  } = param;
    return centered ? "center" : "left";
}, (param)=>{
    let { page  } = param;
    return page && (0,styled_components_browser_esm/* css */.iv)(Title_styles_templateObject());
}, (param)=>{
    let { sub  } = param;
    return sub && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1());
}, (param)=>{
    let { page  } = param;
    return page && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2());
}, (param)=>{
    let { sub  } = param;
    return sub && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3());
});

;// CONCATENATED MODULE: ./components/Title/index.tsx


const Title = (param)=>{
    let { className ="" , children , centered =false , forwardedAs ="div" , page =false , sub =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        as: forwardedAs,
        className: className,
        centered: centered,
        page: page,
        sub: sub,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/index.ts





;// CONCATENATED MODULE: ./data/socials.ts
const socials_socials = [
    {
        link: "mailto:nadinejwebdev@gmail.com",
        type: "mail"
    },
    {
        link: "https://github.com/nadinejuraschek",
        type: "github"
    },
    {
        link: "https://www.linkedin.com/in/nadinepesso",
        type: "linkedin"
    },
    {
        link: "https://www.xing.com/profile/Nadine_Pesso/cv",
        type: "xing"
    },
    {
        link: "https://calendly.com/nadinepesso/15min",
        type: "calendly"
    }
];

;// CONCATENATED MODULE: ./data/index.ts



;// CONCATENATED MODULE: ./layout/Footer/styles.tsx

function Footer_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--secondary);\n  color: var(--neutral_01);\n  font-size: 1.2rem;\n  padding: 20rem var(--section-padding-side) 11rem;\n\n  @media (min-width: 700px) {\n    padding: 19rem var(--section-padding-side) var(--section-padding-side);\n  }\n"
    ]);
    Footer_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--neutral_01);\n  border: none;\n  height: 1px;\n  margin: 2rem 0 1rem;\n"
    ]);
    Footer_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a:not(:last-child) {\n    margin-right: 3rem;\n  }\n"
    ]);
    Footer_styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const Footer_styles_Container = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-a3f3175f-0"
})(Footer_styles_templateObject());
const styles_Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-a3f3175f-1"
})(Footer_styles_templateObject1());
const styles_Socials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3f3175f-2"
})(Footer_styles_templateObject2());

;// CONCATENATED MODULE: ./layout/Footer/index.tsx




const Footer = ()=>{
    const currentYear = new Date().getFullYear();
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Socials, {
                children: socials.map((item, index)=>{
                    const { link , type  } = item;
                    return /*#__PURE__*/ _jsx(Social, {
                        color: "var(--neutral_01)",
                        hoverColor: "var(--tertiary)",
                        link: link,
                        type: type
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            "\xa9 ",
            currentYear,
            " Nadine Pesso"
        ]
    });
};

;// CONCATENATED MODULE: ./layout/FullPageLayout/styles.tsx

function FullPageLayout_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  padding: var(--section-padding-side);\n\n  height: calc(100vh - 8rem);\n  width: 100vw;\n\n  @media (min-width: 700px) {\n    height: calc(100vh - 6rem);\n  }\n"
    ]);
    FullPageLayout_styles_templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc7d5cb0-0"
})(FullPageLayout_styles_templateObject());

;// CONCATENATED MODULE: ./layout/FullPageLayout/index.tsx


const FullPage = (param)=>{
    let { children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: className,
        children: children
    });
};

;// CONCATENATED MODULE: ./layout/index.ts



// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./sections/Maintenance/styles.tsx

function Maintenance_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  height: calc(100vh - 8rem);\n\n  @media (min-width: 700px) {\n    height: calc(100vh - 6rem);\n  }\n"
    ]);
    Maintenance_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Maintenance_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 350px;\n  margin-bottom: 2rem;\n\n  @media (min-width: 400px) {\n    margin-bottom: 6rem;\n  }\n"
    ]);
    Maintenance_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Maintenance_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: contain;\n  height: 100%;\n  width: 100%;\n"
    ]);
    Maintenance_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function Maintenance_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2.5rem;\n  font-weight: bold;\n  line-height: 1.2;\n  text-transform: uppercase;\n\n  @media (min-width: 330px) {\n    font-size: 3rem;\n  }\n\n  @media (min-width: 450px) {\n    font-size: 5rem;\n  }\n"
    ]);
    Maintenance_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.8rem;\n\n  @media (min-width: 450px) {\n    font-size: 2rem;\n  }\n\n  @media (min-width: 700px) {\n    margin: 0 auto;\n    max-width: 80%;\n  }\n\n  @media (min-width: 1200px) {\n    font-size: 2.5rem;\n    max-width: 60%;\n  }\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  background-color: var(--dark_02);\n  padding: 1.5rem 2rem;\n\n  height: 8rem;\n  width: 100%;\n\n  @media (min-width: 700px) {\n    flex-direction: row;\n    align-items: center;\n\n    height: 6rem;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  color: var(--neutral_01);\n  order: 1;\n\n  @media (min-width: 700px) {\n    order: 0;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n\n  order: 0;\n\n  @media (max-width: 700px) {\n    order: 1;\n\n    svg {\n      height: 2.5rem;\n      width: 2.5rem;\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 118px;\n\n  display: none;\n\n  @media (min-width: 700px) {\n    display: block;\n    order: 2;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}




const Layout = (0,styled_components_browser_esm/* default */.ZP)(FullPage).withConfig({
    componentId: "sc-e9cba0e4-0"
})(Maintenance_styles_templateObject());
const Illustration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cba0e4-1"
})(Maintenance_styles_templateObject1());
const StyledImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    componentId: "sc-e9cba0e4-2"
})(Maintenance_styles_templateObject2());
const styles_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Title).withConfig({
    componentId: "sc-e9cba0e4-3"
})(Maintenance_styles_templateObject3());
const styles_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Text).withConfig({
    componentId: "sc-e9cba0e4-4"
})(styles_templateObject4());
const ContactFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-e9cba0e4-5"
})(_templateObject5());
const Copyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cba0e4-6"
})(_templateObject6());
const ContactOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cba0e4-7"
})(_templateObject7());
const Empty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cba0e4-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./assets/illustrations/construction.png
/* harmony default export */ var construction = ({"src":"/_next/static/media/construction.1eddec0a.png","height":735,"width":1108,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEVMaXGHfmPv7+6TmqEAAACfjFjGys3x+Pb5wUH2znjlmHrWwpb////4///XkH23mlfMiYeqqaJXZXLyn3//zlDo49e5vL+UHE78AAAAFnRSTlMAuqThK7T+RbOMg6hoZHy+q6zEr8b91C6o4wAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUCJkFwQkCwBAMAMElSNDW7f9P7QzfQpVeiNulE6dhTtKVZuQRvA81ow/Aqz8ffwFBqtszRQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./sections/Maintenance/index.tsx





const Maintenance = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                            alt: "Under Construction",
                            placeholder: "blur",
                            src: construction
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledTitle, {
                        centered: true,
                        children: "Under Construction"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledText, {
                        centered: true,
                        children: "Come back soon to see a brand new portfolio! In the meantime, feel free to schedule a call or send me a message."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactFooter, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright, {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Nadine Pesso"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactOptions, {
                        children: socials_socials.map((social, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Social_Social, {
                                animated: true,
                                color: "var(--neutral_01)",
                                hoverColor: "var(--tertiary)",
                                link: social.link,
                                type: social.type
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent, {})
        ]
    });

;// CONCATENATED MODULE: ./sections/index.tsx


;// CONCATENATED MODULE: ./pages/index.tsx



const Home = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: "Nadine Pesso | Frontend Developer Portfolio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Maintenance, {})
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);